<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-center text-primary">Editar Datos de la Sede: {{ sede.nombre }}</h3>
    <p class="text-center"><small> Complete el siguiente formulario</small></p>

    <form class="xcard" @submit.prevent="validarCampos" novalidate>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-text-field label="Nombre" outlined dense v-model="sede.nombre" :rules="[rules.required]"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div
              class="input-group input-group-sm"
              :class="{ 'has-error': validation.hasError('sede.unidad_negocio') }">
              <div class="input-group-addon">Unidad Negocio</div>
              <select class="form-control input-sm" type="text" v-model="sede.unidad_negocio">
                <option v-for="(u, ind) in unidades" :key="ind" :value="u.id">{{ u.nombre }}</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('sede.unidad_negocio')">
              {{ validation.firstError('sede.unidad_negocio') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <ACiudades :model="sede" :default="sede.idciudad" />
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.direccion') }">
              <div class="input-group-addon">Direccion</div>
              <input
                v-model.trim="sede.direccion"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.direccion')">
              {{ validation.firstError('sede.direccion') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono_fijo') }">
              <div class="input-group-addon">Telefono fijo</div>
              <input
                v-model.trim="sede.telefono_fijo"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono_fijo')">
              {{ validation.firstError('sede.telefono_fijo') }}
            </div>
          </div>
        </v-col>

        <div class="form-group">
          <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.unidad_negocio') }">
            <div class="input-group-addon">Unidad Negocio</div>
            <select class="form-control input-sm" type="text" v-model="sede.unidad_negocio">
              <option v-for="(u, ind) in unidades" :key="ind" :value="u.id">{{ u.nombre }}</option>
            </select>
          </div>
          <div class="error" v-if="validation.hasError('sede.unidad_negocio')">
            {{ validation.firstError('sede.unidad_negocio') }}
          </div>
        </div>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono1') }">
              <div class="input-group-addon">Telefono 1</div>
              <input
                v-model.trim="sede.telefono1"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono1')">
              {{ validation.firstError('sede.telefono1') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.telefono2') }">
              <div class="input-group-addon">Telefono 2</div>
              <input
                v-model.trim="sede.telefono2"
                type="text"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.telefono2')">
              {{ validation.firstError('sede.telefono2') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.latitud') }">
              <div class="input-group-addon">Latitud</div>
              <input
                v-model.number="sede.latitud"
                type="number"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.latitud')">
              {{ validation.firstError('sede.latitud') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('sede.longitud') }">
              <div class="input-group-addon">Longitud</div>
              <input
                v-model.number="sede.longitud"
                type="number"
                class="form-control"
                placeholder="Caracteres alfabeticos" />
            </div>
            <div class="error" v-if="validation.hasError('sede.longitud')">
              {{ validation.firstError('sede.longitud') }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <div class="form-group">
            <div
              class="input-group input-group-sm"
              :class="{ 'has-error': validation.hasError('gerentesel.idusuario') }">
              <Usuarios :current="false" :xidsede="sede.id" :model="gerentesel" :xdefault="sede.gerente_id" />
              <label class=""> <small> Gerente Sede (firmante del contrato/certificados)</small></label>
            </div>
            <div class="error" v-if="validation.hasError('gerentesel.idusuario')">
              {{ validation.firstError('gerentesel.idusuario') }}
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="sede.zona_franca"
            :label="sede.zona_franca ? 'Es zona franca' : 'No es zona franca'"
            hide-details></v-checkbox>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>

      <p>
        <small class="text-primary">Correos: </small>
        <a href="#" class="btn btn-link btn-sm" @click="addCorreosView">
          <span class="glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delCorreosView">
          <span class="glyphicon glyphicon-minus"></span>
        </a>
      </p>
      <div class="row">
        <div class="col-sm-12">
          <div :key="ind" v-for="(r, ind) in sede.correos">
            <div class="row" style="margin-bottom: 4px">
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.nombre"
                  placeholder="nombre"
                  required="true" />
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.direccion"
                  placeholder="direccion"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <select name="d" class="form-control input-sm" v-model="r.tipo" placeholder="tipo">
                  <option value="0">0 Corporativo</option>
                  <option value="1">1 Personal</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <p>
        <small class="text-primary">Redes sociales: </small>
        <a href="#" class="btn btn-link btn-sm" @click="addRedesView">
          <span class="glyphicon glyphicon-plus"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delRedesView">
          <span class="glyphicon glyphicon-minus"></span>
        </a>
      </p>
      <div class="row">
        <div class="col-sm-12">
          <div :key="ind" v-for="(r, ind) in sede.redesSociales">
            <div class="row" style="margin-bottom: 4px">
              <div class="col-sm-3">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.nombre"
                  placeholder="nombre"
                  required="true" />
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="r.direccion"
                  placeholder="direccion"
                  required="true" />
              </div>
              <div class="col-sm-3">
                <select class="form-control input-sm" type="number" v-model="r.tipo" placeholder="tipo">
                  <option value="0">Facebook</option>
                  <option value="1">Youtube</option>
                  <option value="2">Instagram</option>
                  <option value="3">Twitter</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="mb-0" style="background: #199156">
        <b class="ml-2 white--text"> Cuentas Bancarias: </b>
        <a href="#" class="btn btn-link btn-sm" @click="addBancoView">
          <span class="glyphicon glyphicon-plus white--text"></span>
        </a>
        <a href="#" class="btn btn-link btn-sm" @click="delBancoView">
          <span class="glyphicon glyphicon-minus white--text"></span>
        </a>
      </p>
      <div class="row ma-0">
        <div class="col-sm-12 pt-0" style="background: #e4faef">
          <div :key="ind" v-for="(r, ind) in sede.cuentasBancarias">
            <div class="row mb-0 mt-0" style="margin-bottom: 4px">
              <div class="col-sm-3 pb-0">
                {{ ind + 1 }}.-
                <input
                  style="max-width: 85%; display: inline-block"
                  class="form-control input-sm"
                  maxlength="100"
                  type="text"
                  v-model.trim="r.nombre"
                  placeholder="nombre del banco"
                  required="true" />
              </div>
              <div class="col-sm-3 pb-0">
                <input
                  class="form-control input-sm"
                  maxlength="20"
                  type="text"
                  v-model.trim="r.nro"
                  placeholder="nro de cuenta"
                  required="true" />
              </div>
              <div class="col-sm-3 pb-0">
                <input
                  class="form-control input-sm"
                  maxlength="500"
                  type="text"
                  v-model.trim="r.descripcion"
                  placeholder="tipo de cuenta"
                  required="true" />
              </div>
              <div class="col-sm-3 pb-0">
                <buscarCaja v-on:onselect="onselectCajaNetSuite($event,r)" :defecto="r.cuentanetsuite" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xcard">
        <p class="text-center text-primary">
          Fondo de recibo para sede (840x700)
          <!-- <a href="formato.psd" target="_blank" rel="">Descargar Formato ".psd" (tamano) </a> -->
        </p>
        <div class="form-group form-group-sm">
          <div class="input-group input-group-sm" v-if="$store.state.CARGO.id == 1">
            <div class="input-group-addon">
              <label for="reciboFile" class="btn btn-rounded btn-primary">Seleccione un fondo de recibo</label>
              <input
                type="file"
                style="visibility: hidden"
                id="reciboFile"
                @click="resetImageUploader"
                @change="uploadReciboSede"
                accept=".jpg, .jpeg, .png"
                ref="reciboFile" />
            </div>
          </div>
          <input type="hidden" v-model.trim="sede.modelo_recibo" />
          <div class="error" v-if="validation.hasError('sede.modelo_recibo')">
            {{ validation.firstError('sede.modelo_recibo') }}
          </div>
        </div>
        <div class="container-fluid">
          <img class="img-responsive" alt="recibo fondo" :src="location_bd_recibo_sede + sede.modelo_recibo" />
        </div>
      </div>

      <button v-if="$store.state.CARGO.id == 1" :disabled="!activo" type="submit" class="btn btn-azul center-block white--text mt-8">
        Guardar Cambios
      </button>
    </form>
    <Alertas ref="alertar" />
    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { Validator } from 'simple-vue-validator';
  import ACiudades from '@/components/ACiudades';
  import { error, exito } from '@/components/Utils.js';
  import Alertas from '@/components/AAlertas.vue';
  import xaxios from '@/xaxios';
  import Usuarios from '@/components/AUsuariosActivos';
  import buscarCaja from '@/views/conceptos/buscarCaja.vue';

  export default {
    data() {
      return {
        rules: {
          required: (value) => !!value || 'Campo Obligatorio',
          loanMin: (value) => value >= 1 || 'Valor debe ser mayor a 0',
          loanMinTwo: (monto, bs) => monto == bs || 'Monto no puede ser Diferente de ' + bs,
          loanMax: (monto, saldo) => monto <= saldo || 'Monto no puede ser mayor de ' + saldo,
        },
        menu_name: process.env.VUE_APP_NAME_MENU,
        location_bd_recibo_sede: process.env.VUE_APP_URL_BG_RECIBO_SEDE,
        activo: true,
        gerentesel: { idusuario: '' },
        sede: {
          id: -1,
          nombre: '',
          direccion: '',
          telefono_fijo: '',
          telefono1: null,
          telefono2: null,
          idciudad: null,
          latitud: null,
          longitud: null,
          unidad_negocio: null,
          redesSociales: [],
          cuentasBancarias: [],
          correos: [],
          modelo_recibo: '',
          gerente_id: null,
          // zona_franca: false,
        },
        negocios: [],
        unidades: [],
      };
    },
    components: { ACiudades, Alertas, Usuarios, buscarCaja },
    watch: {},
    validators: {
      'sede.nombre'(value) {
        return Validator.value(value).required();
      },
      'sede.direccion'(value) {
        return Validator.value(value).required();
      },
      'sede.telefono_fijo'(value) {
        return Validator.value(value).required();
      },
      'sede.telefono1'(value) {
        return Validator.value(value).required().digit().minLength(5).maxLength(12);
      },
      'sede.telefono2'(value) {
        return Validator.value(value).required().digit().minLength(5).maxLength(12);
      },
      'sede.idciudad'(value) {
        return Validator.value(value).required();
      },
      'sede.modelo_recibo'(value) {
        return Validator.value(value).required();
      },
      'gerentesel.idusuario'(value) {
        return Validator.value(value).required();
      },
    },
    methods: {
      validarCampos() {
        let idcargo = this.$store.state.CARGO.id;
        if(idcargo > 1){
          window.alert('No autorizado');

          return;
        }
        var vue = this;
        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.sede);
          obj.cuentasBancarias.forEach(c=>delete c.cuentanetsuite);

          if (obj.idciudad) obj.idciudad = obj.idciudad.id;
          if (obj.redesSociales.length == 0) delete obj.redesSociales;
          if (obj.correos.length == 0) delete obj.correos;
          if (obj.cuentasBancarias.length == 0) delete obj.cuentasBancarias;
          if (!obj.unidad_negocio) delete obj.unidad_negocio;  

          var exito = success;
          if (obj.correos) {
            obj.correos.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Correo', 'Ingrese el nombre del correo'));
                exito = false;
                return;
              }
              if (e.direccion.length == 0) {
                vue.$notify(error('Correo', 'Ingrese el correo'));
                exito = false;
                return;
              }
              e.tipo = parseInt(e.tipo);
            });
            if (!exito) return;
          }
          if (!vue.gerentesel.idusuario) {
            vue.$notify(error('Gerente Sede', 'Seleccione al gerente de la sede, para el contrato.'));
            exito = false;
            return;
          }
          if (obj.redesSociales) {
            obj.redesSociales.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Red social', 'Ingrese el nombre del correo'));
                exito = false;
                return;
              }
              if (e.direccion.length == 0) {
                vue.$notify(error('Red social', 'Ingrese el correo'));
                exito = false;
                return;
              }
              e.tipo = parseInt(e.tipo);
            });
            if (!exito) return;
          }
          if (obj.cuentasBancarias) {
            obj.cuentasBancarias.forEach(function (e) {
              if (e.nombre.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese el nombre del banco'));
                exito = false;
                return;
              }
              if (e.descripcion.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese una descripcion de la cuenta'));
                exito = false;
                return;
              }
              if (e.nro.length == 0) {
                vue.$notify(error('Cuenta Bancaria', 'Ingrese el numero de la cuenta'));
                exito = false;
                return;
              } else if (e.nro.length < 7 || e.nro.length > 20) {
                vue.$notify(error('Cuenta Bancaria', 'La cuenta debe tener entre 7 y 20 digitos'));
                exito = false;
                return;
              } else if (!/^\d+$/.test(e.nro)) {
                vue.$notify(error('Cuenta Bancaria', 'La cuenta solamente debe tener entre 7 y 20 digitos'));
                exito = false;
                return;
              }
            });
            if (!exito) return;
          }
          if (exito) {
            vue.activo = false;
            vue.enviarDatos(obj);
          } else {
            vue.$notify(error('Sede', 'Revise los datos ingresados'));
          }
        });
      },
      addCorreosView() {
        this.sede.correos.push({ nombre: '', direccion: '', tipo: 0, idsede: this.sede.id });
      },
      delCorreosView() {
        this.sede.correos.pop();
      },
      addRedesView() {
        this.sede.redesSociales.push({ nombre: '', direccion: '', tipo: 0, idsede: this.sede.id });
      },
      delRedesView() {
        this.sede.redesSociales.pop();
      },
      addBancoView() {
        this.sede.cuentasBancarias.push({ nombre: '', descripcion: '', nro: '', idsede: this.sede.id });
      },
      delBancoView() {
        this.sede.cuentasBancarias.pop();
      },
      async obtenerMasDatos() {
        var vue = this;
        vue.$refs.alertar.cargando();
        await this.getunidades();
        var sql = gql`query{ getSede(id:${this.sede.id}){ id nombre unidad_negocio gerente_id correos{id nombre direccion tipo estado idsede} redesSociales{ id,nombre,direccion,tipo,estado,idsede} cuentasBancarias{id,nombre,descripcion,nro,idsede, cuentanetsuite{id numero cuenta, tipo}} } }`;

        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var res = data.data.getSede;
            window.console.log('GET:', res);
            var cs = res.correos;
            var rs = res.redesSociales; 
            let cuentasb = [];
            vue.sede.gerente_id = res.gerente_id;

            cs.forEach(function (e) {
              vue.sede.correos.push({ nombre: e.nombre, direccion: e.direccion, tipo: e.tipo, idsede: e.idsede });
            });
            rs.forEach(function (e) {
              vue.sede.redesSociales.push({ nombre: e.nombre, direccion: e.direccion, tipo: e.tipo, idsede: e.idsede });
            });
            res.cuentasBancarias.forEach(function (e) {
              if(e.cuentanetsuite) e.cuentanetsuite.texto = `${e.cuentanetsuite.cuenta} (${e.cuentanetsuite.numero})`;
              cuentasb .push({
                nombre: e.nombre,
                descripcion: e.descripcion,
                nro: e.nro,
                idsede: e.idsede,
                cuentanetsuite: e.cuentanetsuite
              });
            });
            vue.sede.cuentasBancarias = cuentasb;

            if (res.unidad_negocio) {
              vue.sede.unidad_negocio = '' + res.unidad_negocio;
            }
            vue.$refs.alertar.reset();
          })
          .catch(() => {
            //vue.activo = false;
            vue.$refs.alertar.invalido();
          });
      },
      resetImageUploader: function () {
        this.sede.modelo_recibo = null;
        this.$refs.reciboFile.value = '';
      },
      uploadReciboSede: function () {
        const img_file = this.$refs.reciboFile.files[0];
        if (img_file.size / 1000 < 1024) {
          let url = `${process.env.VUE_APP_URL_WEBDATA}recibo_upload.php`;

          let formData = new FormData();
          formData.append('file', img_file);

          xaxios
            .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data: { status, msg, fileNameRecibo } }) => {
              this.sede.modelo_recibo = status ? fileNameRecibo : null;
              this.$notify(exito('Recibo ', msg));
            })
            .catch((error) => {
              this.resetImageUploader();
              this.$notify(error('Error: ' + url, error));
            });
        } else {
          this.resetImageUploader();
          this.$notify(error('Recibo', 'El archivo debe ser Menor a 1MB'));
        }
      },

      async getunidades() {
        var vue = this;
        this.loadingunidades = true;
        let s = `query { NegociosAll { id nombre } }`;
        var sql = gql`
          ${s}
        `;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var dat = data.data.NegociosAll;
            dat.map((x) => {
              x.text = x.nombre;
            });
            vue.unidades = dat;
            vue.loadingunidades = false;
          })
          .catch((error) => {
            vue.loadingunidades = false;
            window.console.error(error);
          });
      },
      onselectCajaNetSuite(e,r){
        window.console.log('>>>>>>>>>>>>>>>>>>',e,r);
        if(e) r.cuenta_netsuite_id = e.id;
        else delete r.cuenta_netsuite_id;
      },

      enviarDatos(obj) {
        var vue = this;
        vue.$refs.alertar.cargando();
        var unidad = obj.unidad_negocio;
        if (unidad) {
          obj.unidad_negocio = '1'; //FIXME
        }
        obj.gerente_id = vue.gerentesel.idusuario.id;
        var ob = window.stringifyObject(obj);
        if (ob.includes('unidad_negocio')) {
          ob = ob.replace('unidad_negocio: "1"', 'unidad_negocio:' + unidad);
        }
        var sql = gql`mutation{updateSede(input:${ob}){ok,errors{message}}}`;
        window.console.log(sql.loc.source.body);
        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then((data) => {
            var res = data.data.updateSede;
            if (res.ok) {
              vue.$refs.alertar.success();
              this.$root.$notify.show('Datos actualizados de Sede', { color: 'success' });
            } else {
              this.activo = true;
              var errores = JSON.stringify(data.data.updateSede.errors);
              var ob = JSON.parse(errores);
              var vals = '';
              ob.forEach(function (k) {
                delete k.__typename;
                vals += Object.values(k) + ' \n\t';
              });
              this.$notify(error('Sede', vals));
              vue.$refs.alertar.invalido(vals);
            }
            vue.activo = true;
          })
          .catch(() => {
            this.$root.$notify.show('Error: updateSede', { color: 'red' });
            vue.activo = true;
          });
      },
    },
    mounted() {
      var xp = sessionStorage.xsede;
      if (xp != null) {
        var p = JSON.parse(xp);
        this.sede.id = p.id;
        this.sede.nombre = p.nombre;
        this.sede.direccion = p.direccion;
        this.sede.telefono_fijo = p.telefono_fijo;
        this.sede.telefono1 = p.telefono1;
        this.sede.telefono2 = p.telefono2;
        this.sede.latitud = p.latitud;
        this.sede.longitud = p.longitud;
        this.sede.modelo_recibo = p.modelo_recibo;
        this.sede.idciudad = { id: p.ciudad.id, nombre: p.ciudad.nombre };
        this.obtenerMasDatos();
      }
    },
  };
</script>
